var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconEntities = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76186 2.8623H18.3174C18.8282 2.8623 19.3181 3.06521 19.6793 3.4264C20.0404 3.78758 20.2433 4.27744 20.2433 4.78823V22.1216H4.83594V4.78823C4.83594 4.27744 5.03885 3.78758 5.40003 3.4264C5.76121 3.06521 6.25108 2.8623 6.76186 2.8623ZM6.76186 20.1956H10.6137V16.3438H14.4656V20.1956H18.3174V4.78823H6.76186V20.1956ZM13.5026 6.71416H16.3915V9.60305H13.5026V6.71416ZM8.68779 11.529H11.5767V14.4179H8.68779V11.529ZM13.5026 11.529H16.3915V14.4179H13.5026V11.529ZM8.68779 6.71416H11.5767V9.60305H8.68779V6.71416Z",
    fill: "#420080"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconEntities, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-entities.c0cb14ed.svg";
export { ForwardRef as ReactComponent };